// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as React from "react";
import * as Scalar from "../../core/Scalar.res.js";
import * as Placeholder from "../../resources/layout-and-structure/Placeholder.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as CatalogProductPage from "./CatalogProductPage.res.js";
import * as CatalogProduct__Config from "./CatalogProduct__Config.res.js";
import * as CatalogProduct__Queries from "./CatalogProduct__Queries.res.js";

function CatalogProductContainer(props) {
  let cku = props.cku;
  let match = CatalogProduct__Queries.ProductQuery.useLazy(undefined, undefined, undefined, undefined, "CacheAndNetwork", undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  let queryResults = match[1];
  let executeQuery = match[0];
  let match$1 = CatalogProduct__Queries.ProductShopsQuery.useLazy(undefined, undefined, undefined, undefined, "NetworkOnly", undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  let queryShopsResults = match$1[1];
  let executeShopsQuery = match$1[0];
  let activeShop = Auth.useActiveShop();
  let activeShopId = Stdlib_Option.map(activeShop, shop => shop.id);
  React.useEffect(() => {
    executeQuery(undefined, undefined, CatalogProduct__Queries.ProductQuery.makeVariables(Scalar.CKU.serialize(cku), CatalogProduct__Config.makeFilterBy(activeShopId), CatalogProduct__Queries.ProductQuery.makeInputObjectInputProductVariantsQueryFilter("INCLUDED", undefined), undefined));
  }, [activeShopId]);
  React.useEffect(() => {
    executeShopsQuery(undefined, undefined, CatalogProduct__Queries.ProductShopsQuery.makeVariables(Scalar.CKU.serialize(cku), undefined));
  }, []);
  let productShopIds;
  if (queryShopsResults.TAG === "Executed") {
    let data = queryShopsResults._0.data;
    productShopIds = data !== undefined ? data.productsByVariantCku.edges.map(param => param.node.shop.id) : [];
  } else {
    productShopIds = [];
  }
  if (queryResults.TAG !== "Executed") {
    return JsxRuntime.jsx(Placeholder.make, {
      status: "Loading"
    });
  }
  let match$2 = queryResults._0;
  let data$1 = match$2.data;
  if (data$1 !== undefined) {
    return JsxRuntime.jsx(CatalogProductPage.make, {
      cku: cku,
      productShopIds: productShopIds,
      shopsProduct: CatalogProduct__Config.productsInformationFromData(data$1),
      shopsProductVariants: CatalogProduct__Config.productsVariantsFromData(data$1)
    });
  } else if (match$2.loading) {
    return JsxRuntime.jsx(Placeholder.make, {
      status: "Loading"
    });
  } else {
    return JsxRuntime.jsx(Placeholder.make, {
      status: "Error"
    });
  }
}

let make = React.memo(CatalogProductContainer);

let Config;

let ProductQuery;

let ProductShopsQuery;

export {
  Config,
  ProductQuery,
  ProductShopsQuery,
  make,
}
/* make Not a pure module */
